import React, { useState } from 'react'
import { l } from '@manychat/manyui'

import { NODE_CREATE_TRIGGER_BUTTON_ID } from 'common/builder/components/chart/FlowChart/constants'

import * as styles from './AddTriggerButtonNew.styles'

interface AddTriggerButtonProps {
  onClick: () => void
  /**
   * Muted style for button
   */
  muted?: boolean
}

export const AddTriggerButtonNew = React.memo(({ onClick, muted }: AddTriggerButtonProps) => {
  const [isHover, setIsHover] = useState(false)

  const btnStyle = muted ? styles.BtnWithTriggersStyle : styles.BtnStyle
  const btnStyleWithHover = isHover ? styles.BtnHoverStyle : btnStyle

  const btnCaptionStyle = isHover ? styles.BtnHoverCaptionStyle : styles.BtnCaptionStyle

  return (
    <view
      name={NODE_CREATE_TRIGGER_BUTTON_ID}
      style={btnStyleWithHover}
      onClick={onClick}
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      cursor="pointer"
    >
      <richtext style={btnCaptionStyle} text={l.translate('+ New Trigger')} />
    </view>
  )
})
